export const pictureMimes = [
  'image/png',
  'image/jpg',
  'image/jpeg',
  'application/pdf',
];

export const svgMime = [
  'image/svg+xml',
];
